import moment from 'moment-timezone/builds/moment-timezone-with-data';

export const setMonthOpen = (startDate, endDate, focusedInput) => {
  //THESE TOP TWO FUNCTIONS CHECK IF WE ARE ON THE LAST DATE OF THE MONTH,
  //SINCE WE DON'T DO SAME DAY RENTAL, WE JUST SHOW THE NEXT MONTH THEN.
  if (focusedInput === "startDate" && startDate === null && endDate === null) {
    if (
      moment()
        .endOf("month")
        .format("YYYY-MM-DD")
        .toString() ===
      moment()
        .format("YYYY-MM-DD")
        .toString()
    ) {
      return moment().add(1, "month");
    }
    return moment();
  }

  //THESE TOP TWO FUNCTIONS CHECK IF WE ARE ON THE LAST DATE OF THE MONTH,
  //SINCE WE DON'T DO SAME DAY RENTAL, WE JUST SHOW THE NEXT MONTH THEN.
  if (focusedInput === "endDate" && startDate === null && endDate === null) {
    if (
      moment()
        .endOf("month")
        .format("YYYY-MM-DD")
        .toString() ===
      moment()
        .format("YYYY-MM-DD")
        .toString()
    ) {
      return moment().add(1, "month");
    }
    return moment();
  }

  if (focusedInput === "startDate") {
    if (startDate && endDate) {
      return startDate;
    }

    if (startDate === null && endDate) {
      return endDate;
    }

    if (startDate && endDate === null) {
      return startDate;
    }
  }

  if (focusedInput === "endDate") {
    if (startDate && endDate) {
      return endDate;
    }

    if (startDate === null && endDate) {
      return endDate;
    }

    if (startDate && endDate === null) {
      return startDate;
    }
  }

  return moment();
};
